import React from 'react';
import PropTypes from 'prop-types';

class BodyScroll extends React.Component {
  static propTypes = {
    isScroll: PropTypes.bool,
  };
  static defaultProps = {
    isScroll: false,
  };
  componentDidMount() {
    document.body.classList.toggle('noScroll', this.props.isScroll);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    document.body.classList.toggle('noScroll', nextProps.isScroll);
  }
  componentWillUnmount() {
    document.body.classList.remove('noScroll');
  }
  render() {
    return null;
  }
}

export default BodyScroll;



// WEBPACK FOOTER //
// ./src/components/BodyScroll/BodyScroll.js